import * as apodization from './data1d/filter1d/apodization/apodization';
import * as baselineCorrection from './data1d/filter1d/baselineCorrection';
import * as digitalFilter from './data1d/filter1d/digitalFilter';
import * as equallySpaced from './data1d/filter1d/equallySpaced';
import * as exclusionZones from './data1d/filter1d/exclusionZones';
import * as fft from './data1d/filter1d/fft';
import * as phaseCorrection from './data1d/filter1d/phaseCorrection';
import * as shiftX from './data1d/filter1d/shiftX';
import * as signalProcessing from './data1d/filter1d/signalProcessing';
import * as zeroFilling from './data1d/filter1d/zeroFilling';
import * as shift2DX from './data2d/filter2d/shiftX';
import * as shift2DY from './data2d/filter2d/shiftY';
import * as fftDimension1 from './data2d/filter2d/fftDimension1';
import * as fftDimension2 from './data2d/filter2d/fftDimension2';
export { apodizationFilter } from './data1d/filter1d/apodization/apodizationFilter';
export const Filters = {
    apodization,
    exclusionZones,
    signalProcessing,
    baselineCorrection,
    digitalFilter,
    equallySpaced,
    fft,
    fftDimension1,
    fftDimension2,
    phaseCorrection,
    shiftX,
    zeroFilling,
    shift2DX,
    shift2DY,
};
//# sourceMappingURL=Filters.js.map